import { tallyIntegrationActionTypes } from '../../actions/integrations/tallyIntegrationActions';

const TallyIntegrationReducers = (state = { }, action) => {
  switch (action.type) {
  case tallyIntegrationActionTypes.GET_TALLY_CONNECTIONS.LOADING: {
    const { getTallyConnectionsLoading } = action;
    return {
      ...state,
      getTallyConnectionsLoading,
    };
  }
  case tallyIntegrationActionTypes.GET_TALLY_CONNECTIONS.SUCCESS: {
    const { tallyConnections } = action;
    return {
      ...state,
      tallyConnections,
    };
  }

  case tallyIntegrationActionTypes.DELETE_TALLY_CONNECTION.LOADING: {
    const { deleteTallyConnectionLoading } = action;
    return {
      ...state,
      deleteTallyConnectionLoading,
    };
  }

  case tallyIntegrationActionTypes.CONNECT_TO_TALLY.LOADING: {
    const { connectToTallyLoading } = action;
    return {
      ...state,
      connectToTallyLoading,
    };
  }

  case tallyIntegrationActionTypes.CONNECT_TO_TALLY.SUCCESS: {
    const { connectedToTally } = action;
    return {
      ...state,
      connectedToTally,
    };
  }

  case tallyIntegrationActionTypes.CONNECT_TENANT_TO_TALLY_LOCATION.LOADING: {
    const { connectTenantToTallyLocationLoading } = action;
    return {
      ...state,
      connectTenantToTallyLocationLoading,
    };
  }

  case tallyIntegrationActionTypes.SYNC_TALLY_PRODUCT.LOADING: {
    const { syncProductLoading } = action;
    return {
      ...state,
      syncProductLoading,
    };
  }

  case tallyIntegrationActionTypes.SYNC_TALLY_VENDOR.LOADING: {
    const { syncVendorLoading } = action;
    return {
      ...state,
      syncVendorLoading,
    };
  }

  case tallyIntegrationActionTypes.SYNC_TALLY_GRN.LOADING: {
    const { syncTallyGRNLoading } = action;
    return {
      ...state,
      syncTallyGRNLoading,
    };
  }

  case tallyIntegrationActionTypes.SYNC_TALLY_INVOICE.LOADING: {
    const { syncTallyInvoiceLoading } = action;
    return {
      ...state,
      syncTallyInvoiceLoading,
    };
  }

  case tallyIntegrationActionTypes.SYNC_TALLY_CN.LOADING: {
    const { syncTallyCreditNoteLoading } = action;
    return {
      ...state,
      syncTallyCreditNoteLoading,
    };
  }

  case tallyIntegrationActionTypes.SYNC_TALLY_PO.LOADING: {
    const { syncPOLoading } = action;
    return {
      ...state,
      syncPOLoading,
    };
  }

  case tallyIntegrationActionTypes.SYNC_TALLY_DN.LOADING: {
    const { syncDNLoading } = action;
    return {
      ...state,
      syncDNLoading,
    };
  }

  case tallyIntegrationActionTypes.PULL_TALLY_PRODUCTS.LOADING: {
    const { pullTallyProductsLoading } = action;
    return {
      ...state,
      pullTallyProductsLoading,
    };
  }

  case tallyIntegrationActionTypes.PULL_TALLY_VENDORS.LOADING: {
    const { pullTallyVendorsLoading } = action;
    return {
      ...state,
      pullTallyVendorsLoading,
    };
  }

  case tallyIntegrationActionTypes.PULL_TALLY_VENDOR_PAYMENT.LOADING: {
    const { pullTallyVendorPaymentLoading } = action;
    return {
      ...state,
      pullTallyVendorPaymentLoading,
    };
  }

  case tallyIntegrationActionTypes.REFRESH_TALLY_CONNECTIONS.LOADING: {
    const { refreshTallyConnectionsLoading } = action;
    return {
      ...state,
      refreshTallyConnectionsLoading,
    };
  }
  case tallyIntegrationActionTypes.PULL_TALLY_CUSTOMERS.LOADING: {
    const { pullTallyCustomersLoading } = action;
    return {
      ...state,
      pullTallyCustomersLoading,
    };
  }

  case tallyIntegrationActionTypes.GET_TALLY_DOCUMENTS.LOADING: {
    const { getTallyDocumentsLoading } = action;
    return {
      ...state,
      getTallyDocumentsLoading,
    };
  }
  case tallyIntegrationActionTypes.GET_TALLY_DOCUMENTS.SUCCESS: {
    const { tallyDocuments } = action;
    return {
      ...state,
      tallyDocuments,
    };
  }

  case tallyIntegrationActionTypes.GET_TALLY_UNMAPPED_DOCUMENTS.LOADING: {
    const { getTallyUnMappedDocumentsLoading } = action;
    return {
      ...state,
      getTallyUnMappedDocumentsLoading,
    };
  }
  case tallyIntegrationActionTypes.GET_TALLY_UNMAPPED_DOCUMENTS.SUCCESS: {
    const { tallyUnMappedDocuments } = action;
    return {
      ...state,
      tallyUnMappedDocuments,
    };
  }

  case tallyIntegrationActionTypes.SYNC_TALLY_DOCUMENTS.LOADING: {
    const { syncTallyDocumentsLoading } = action;
    return {
      ...state,
      syncTallyDocumentsLoading,
    };
  }

  case tallyIntegrationActionTypes.UPDATE_TALLY_EXCLUDED_DOCUMENTS.LOADING: {
    const { updateTallyDocumentsLoading } = action;
    return {
      ...state,
      updateTallyDocumentsLoading,
    };
  }

  case tallyIntegrationActionTypes.TALLY_DOCUMENTS_COUNT.LOADING: {
    const { getTallyDocumentsCountLoading } = action;
    return {
      ...state,
      getTallyDocumentsCountLoading,
    };
  }
  case tallyIntegrationActionTypes.TALLY_DOCUMENTS_COUNT.SUCCESS: {
    const { tallyDocumentsCount } = action;
    return {
      ...state,
      tallyDocumentsCount,
    };
  }

  default: {
    return state;
  }
  }
};

export default TallyIntegrationReducers;
